import React from 'react';
import { Grid, Button } from '@material-ui/core';
// import AuthStar from '../../../assets/images/authstaricon.gif';
import AuthBannerApp from '../../../assets/images/app_banner_auth.png';
import AutoPilotIcon from '../../../assets/images/autopilot_icon.svg';
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons';
import appqrcode from '../../../assets/images/app-qr-code.svg';

function RightContent() {
  return (
    <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_img_fullwidth">
      <div className="slogan-container slogan-image-holder ">
        <div className="slogan-center contentRight_top">
          <img src={AutoPilotIcon} />
          <h2>
            Autopilot increased <span style={{ color: '#5433ff' }}>50%</span> sales on our Amazon Products, and achieved
            Overall Growth of <span style={{ color: '#5433ff' }}>3X</span>. The best part, we got Amazon's Choice badge.
          </h2>
          <div className="d-none d-md-block web_show">
            <p className="sectionCardHeading" style={{ margin: '0' }}>
              - Sharan Pavan
            </p>
            <p className="sectionPara" style={{ margin: '2px 0 0 11px' }}>
              Founder & CEO at Biteful
            </p>
          </div>
          <a
            href="https://support.sellergeni.com/en/articles/6758298-enable-sellergeni-auto-pilot"
            target="_blank"
            rel="noopener noreferrer"
            className="aisleSecondarycanelButton"
            style={{
              background: 'rgb(30, 56, 234)',
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 'fit-content',
              marginTop: '2em',
            }}
          >
            <span style={{ verticalAlign: 'middle' }}>How to launch Autopilot?</span>
            <ArrowForwardIcon
              style={{ verticalAlign: 'middle', width: '20px', marginLeft: '6px', transform: 'rotate(312deg)' }}
            />
          </a>
        </div>
        <div className="slogan-center bgColor_appdownload contentRight_bottom">
          <div style={{ marginRight: '2em' }}>
            <h2>Growth performance tracking made easy. Download app to monitor on the go.</h2>
            <div className="popup-qrScan-holder">
              <Button
                className="aisleSecondarycanelButton showScanner"
                style={{
                  background: 'rgb(30, 56, 234)',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 'fit-content',
                  marginTop: '1em',
                }}
              >
                Download the app
              </Button>
              <div className="popup-qrScan">
                <div className="cards_shadow" style={{ borderRadius: '10px', background: '#101828' }}>
                  <div className="section_para" style={{ marginBottom: '12px', color: '#fff' }}>
                    Scan QR code to download the app
                  </div>
                  <img src={appqrcode} style={{ width: '256px', border: '3px solid #F1F1F1', borderRadius: '12px' }} />
                </div>
              </div>
            </div>
          </div>
          <img className="bgimage_auth_app" src={AuthBannerApp} style={{ width: '100%', height: '100%' }} />
        </div>
        {/* <img className="bgimage_auth_dashboard" src={AuthBanner} /> */}
      </div>
    </Grid>
  );
}
export default RightContent;
